import { FC } from "react";
import { Alert, Box, Typography } from "@mui/material";
import { InfoOutlined } from "@mui/icons-material";

export type AssessmentInstituteRequiredEmptyStateProps = {
  /** Plain-language section name, e.g. "report card templates". */
  sectionLabel?: string;
  "data-testid"?: string;
};

/**
 * Shared empty state when no institute is selected (Story 7.7).
 * Parent supplies the page header and tabs; this is tab body content only.
 */
export const AssessmentInstituteRequiredEmptyState: FC<
  AssessmentInstituteRequiredEmptyStateProps
> = ({
  sectionLabel,
  "data-testid": testId = "assessment-institute-required-empty",
}) => (
  <Box data-testid={testId} sx={{ py: 2 }}>
    <Alert severity="info" icon={<InfoOutlined fontSize="inherit" />}>
      {sectionLabel ? (
        <>
          <Typography variant="body2" gutterBottom>
            To work with <strong>{sectionLabel}</strong> here, select an
            institute from the dashboard first.
          </Typography>
          <Typography variant="body2" color="text.secondary">
            The institute selector on the dashboard chooses which school you are
            managing; Assessment features apply per institute.
          </Typography>
        </>
      ) : (
        <Typography variant="body2">
          Select an institute from the dashboard to use Assessment & Scoring
          features.
        </Typography>
      )}
    </Alert>
  </Box>
);
